import { LobbyImage } from '@colonist/types';
import { createDivIn, createImgIn, createParagraphIn } from '../../ui_utils/DomUtils.ts';
export class UIProgressBarElement {
    update(data) {
        this.container.replaceChildren();
        this.render(data);
    }
    render(data) {
        if (data.showLockIcon) {
            createImgIn(this.container, LobbyImage.LockOn, 'mm-locked-progress-lock-icon');
        }
        const barContainer = createDivIn(this.container, 'mm-locked-progress-bar-wrapper');
        const bar = createDivIn(barContainer, 'mm-locked-progress-bar');
        const isEmpty = data.current == 0;
        for(let i = 0; i < data.total; i++){
            const segment = createDivIn(bar, i < data.current ? 'mm-progress-segment filled' : 'mm-progress-segment');
            segment.style.setProperty('--segment-index', i.toString());
            segment.style.setProperty('--total-segments', data.total.toString());
            if (isEmpty) segment.classList.add('empty-animated');
        }
        createParagraphIn(barContainer, data.label, 'mm-locked-progress-label');
    }
    constructor(parent, data){
        this.container = createDivIn(parent, 'mm-mode-card-bottom-row');
        this.render(data);
    }
}
